import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { CustomerProfile } from '@/models';
import { HeaderFlags } from '@/store/ui';
import { Routes } from '@/router';

@Component({
  name: 'CmgHeaderUserIcon',
})
export default class CmgHeaderUserIcon extends Vue {
  @Prop({ default: false, type: Boolean })
  blur!: boolean;


  get headerOptions() {
    return this.$appStore.state.ui.header.options;
  }

  get headerFlags() {
    return this.headerOptions.flags;
  }

  get allHeaderFlags() {
    return HeaderFlags;
  }

  get signInImageUrl(): string {
    const icons = this.$appStore.state.cms.images.icons;

    return this.$services.loyalty.isEnrolledInLoyalty(this.customer) ? icons.userOutlineHalo.default : icons.userOutline.default;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get isCustomerLoggedIn(): boolean | undefined {
    return this.$services.customer.isLoggedIn();
  }

  get isCustomerInitialized(): boolean {
    return this.isCustomerLoggedIn !== undefined;
  }

  get siteCountryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }


  onClickSignIn(event: any) {
    // If on sign-in page or create-account page, don't open
    // the modal.
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    if (this.$router.currentRoute.name == Routes.SignIn || this.$router.currentRoute.name == Routes.CreateAccount) {
      this.$router.push({ name: Routes.SignIn });
    } else {
      this.$services.ui.setModalVisibility('signIn', true);
      this.$services.ui.firstFocus();
    }
  }

  showAccountMenu(event: any) {
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    this.$services.ui.setModalVisibility('account', true);
    Vue.nextTick(() => this.$services.ui.focusDiv('.modal-content'));
  }

}
